<template>
	<div>
		<x-modal-basic
			:wWidth="1080"
			v-if="showModel"
			@cancel="cancel"
			@close="cancel"
			:loading="loading"
			@ok="saveLayout"
			ok-text="Save Layout"
			:hide-ok="_.isEqual(sidebar, layout) ? true : false"
            :hide-ok-secondary="_.isEqual(defaultLayoutNoOrder, sidebarNoOrder) ? true : false"
			ok-secondary-text="Revert To Default Layout"
			ok-secondary-type="warning"
			@okSecondary="revertLayout"
			:ok-disabled="loading"
			:ok-secondary-disabled="loading"
		>
			<div slot="title" :class="`slot-title d-flex justify-content-between align-items-center`">
				Organise {{ isCommercial ? "Commercial" : "Consumer" }} Application Tabs
			</div>

			<el-row :gutter="10">
				<el-col :span="24">
					<!-- <el-col :span="isCommercial ? 12 : 24"> -->
					<draggable v-model="layout" ghost-class="ghost">
						<transition-group>
							<div class="dashboard-item" v-for="list in layout" :key="list.name">
								<div class="item-inner">
									<font-awesome-icon :icon="['fas', 'arrows-alt-v']" />
									{{ list.title }}
								</div>
							</div>
						</transition-group>
					</draggable>
				</el-col>
				<!-- <el-col v-if="isCommercial" :span="12">

                </el-col> -->
			</el-row>
		</x-modal-basic>
	</div>
</template>

<script>
	import { mapGetters } from "vuex"
	import draggable from "vuedraggable"

	export default {
		name: "OrganiseAppTabs",
		components: {
			draggable,
		},
		props: {
			applicationId: {
				required: true,
			},
		},
		data() {
			return {
				loading: false,
				showModel: true,
				newLayout: [],
			}
		},
		mounted() {
			this.showModel = true
		},
		computed: {
			...mapGetters({
				application: "initAppData",
				sidebar: "appTabLayout/getSidebar",
				defaultLayout: "appTabLayout/getDefaultLayout",
			}),
			isCommercial() {
				return this.application.application_type_id == 2 ? true : false
			},
			layout: {
				get() {
					return this.$store.getters["appTabLayout/getLayout"]
				},
				set(layout) {
					this.$store.dispatch("appTabLayout/setLayout", layout)
				},
			},
            sidebarNoOrder() {
                return this.sidebar.map(sidebar => {
                    return {
                        title: sidebar.title,
                        name: sidebar.name
                    }
                })
            },
            defaultLayoutNoOrder() {
                return this.defaultLayout.map(sidebar => {
                    return {
                        title: sidebar.title,
                        name: sidebar.name
                    }
                })
            }
		},
		methods: {
			cancel() {
				this.showModel = false
				this.$bus.$emit("close-create-modal", "")
				this.$store.dispatch("appTabLayout/setLayout", this.sidebar)
			},
			revertLayout() {
				this.loading = true
				this.$tenant
					.post("/api/v2/user-settings/delete", {
						remove: this.isCommercial ? 'commercialLayout' : 'consumerLayout',
					})
					.then((res) => {
						this.$store.dispatch("user/setSettings", res.data)
						this.$store.dispatch("appTabLayout/setLayout", this.defaultLayout)
						this.$store.dispatch("appTabLayout/setSidebar", this.defaultLayout)
						this.loading = false
						this.showModel = false
						this.$bus.$emit("close-create-modal", "")
					})
					.catch((err) => {
						console.error(err)
					})
			},
			saveLayout() {
				this.loading = true
				let order = 1
				let newLayout = Object.assign([], this.layout)
				newLayout.map((layout) => {
					layout.order = order++
				})

				let saveLayout = {}
				if (this.isCommercial) {
					saveLayout.commercialLayout = newLayout
				} else {
					saveLayout.consumerLayout = newLayout
				}

				this.$tenant
					.put("/api/v2/user-settings", saveLayout)
					.then((res) => {
						this.$store.dispatch("user/setSettings", res.data)
						this.$store.dispatch("appTabLayout/setLayout", newLayout)
						this.$store.dispatch("appTabLayout/setSidebar", newLayout)
						this.loading = false
						this.showModel = false
						this.$bus.$emit("close-create-modal", "")
					})
					.catch((err) => {
						console.error(err)
					})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.dashboard-item {
		width: 100%;
		height: 20px;
		border: 1px solid #cccccc;
		margin: 0 0 10px 0;
		display: flex;
		align-items: center;
		padding: 20px;
		font-size: 16px;
		opacity: 1;
		cursor: pointer;

		svg {
			margin: 0 20px 0 0;
		}

		&.ghost {
			opacity: 0;
		}
	}
</style>
